// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import styled from 'styled-components';
import {
  MobileListItem,
  MobileListWrapper,
} from '../utils/Styles/MobileListItem';

const StyledMobileListItem = styled(MobileListItem)`
  .item {
    max-width: 100%;
  }
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const RnrsListMobile = ({ rnrs, getFormattedDateSubmitted, onRowClick }) => (
  <MobileListWrapper>
    {/* TODO: Fix this the next time the file is edited. */}
    {/* eslint-disable-next-line react/prop-types */}
    {rnrs.map(item => (
      <StyledMobileListItem
        key={item.createdAt}
        onClick={event => onRowClick(event, item.productId)}
      >
        <div>
          <div className='item'>Product ID: {item.productId}</div>
          <div className='item'>Rating: {item.rating}</div>
          <div className='item'>Review: {item.review}</div>
          <div className='item'>Vendor Review: {item.vendorReview}</div>
          <div className='item'>User ID: {item.userId}</div>
        </div>
        <div>
          <div className='label-item'>
            {getFormattedDateSubmitted(item.createdAt)}
          </div>
        </div>
      </StyledMobileListItem>
    ))}
  </MobileListWrapper>
);

export default RnrsListMobile;
